import { PageBody, PageBodyProps } from './PageBody';

type ModalBody = Omit<PageBodyProps, 'isMain'>; // we will move from isMain to optional skipMain in the future

/**
 * This is an equivalent of PageBody meant to be used inside modals and drawers.
 */
export const ModalBodyLayout = (props: ModalBody) => (
  <PageBody {...props} isMain={false} />
);
